import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { UserService } from '../services/user.service';
const defaults = {
    notif: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50
    }
}
@Component({
    selector: 'app-addeditcustomer',
    templateUrl: './addeditcustomer.component.html',
    styleUrls: ['./addeditcustomer.component.css']
})
export class AddEditCustomers implements OnInit{
    element: any = {};
    phonecodelist: any = []
    myForm: any = FormControl;
    constructor(
        public dialogRef: MatDialogRef<AddEditCustomers>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private userService: UserService,
        private notifSer: NotificationsService,
        public fb: FormBuilder,
    ) {
        this.element = data;

        this.myForm = this.fb.group({
            name: ['', [Validators.required]],
            short_name: ['', [Validators.required]],
            email: ['', [Validators.required]],
            phonecode: ['', [Validators.required]],
            phone: ['', [Validators.required]],
            referal_code: [''],
        });

    }
    ngOnInit() {
        this.getCountry();
    }
    getCountry() {
        this.userService.country().subscribe(res => {
            var arr = res.sort(this.sort_by("phonecode", true, parseInt));
            var result = arr.reduce((unique, o) => {
                if (!unique.some(obj => obj.phonecode === o.phonecode)) {
                    unique.push(o);
                }
                return unique;
            }, []);
            this.phonecodelist = result;
        }, (err) => {
            console.log(err);
        });
    }
    sort_by(field, reverse, primer) {
        var key = primer ?
            function (x) { return primer(x[field]) } :
            function (x) { return x[field] };

        reverse = [-1, 1][+!!reverse];

        return function (a, b) {
            return a = key(a), b = key(b), reverse * (+(a > b) - +(b > a));
        }
    }
    async saveCustomer() {
        this.userService.csrf().subscribe(data => {
            const { notif } = defaults
            this.element['_csrf'] = data['_csrf'];
            this.element['group'] = 'customer';
            if (this.myForm.valid) {
                this.userService.addNewCustomer(this.element).subscribe(data => {
                    if (data.status) {
                        this.notifSer.success('Success', data.message, notif)
                        // Emit the form data when closing the dialog

                        this.dialogRef.close({ success: true, data: data });

                    } else this.notifSer.error('Error', data.message, notif);
                }, err => this.notifSer.error('Error', err.error.message, notif))
            }
        })

    }

}


// WEBPACK FOOTER //
// ./src/app/addeditcustomer/addeditcustomer.component.ts